import {
  Box,
  Button as BaseButton,
  ButtonProps as BaseButtonProps,
  forwardRef,
} from '@chakra-ui/react';
import { ImArrowLeft2, ImArrowRight2 } from 'react-icons/im';

type Props = BaseButtonProps;

const Button = forwardRef(({ variant, ...props }: Props, ref) => {
  if (variant === 'renoGreenText') {
    return (
      <BaseButton
        ref={ref}
        bg="none"
        backgroundColor="none"
        color="primaryColor"
        _hover={{
          color: 'primaryColor_hover',
          bg: 'none',
        }}
        _focus={{
          border: 'none',
        }}
        _active={{
          border: 'none',
          color: 'primaryColor_hover',
          bg: 'none',
        }}
        {...props}
      />
    );
  }
  if (variant === 'backButton') {
    return (
      <BaseButton
        ref={ref}
        color="backButtonColor"
        leftIcon={
          <Box mt="-4px">
            <ImArrowLeft2 />
          </Box>
        }
        bg="none"
        padding="10px 30px 10px 10px !important"
        backgroundColor="none"
        _hover={{
          color: 'primaryColor_hover',
          bg: 'none',
        }}
        _focus={{
          border: 'none',
        }}
        _active={{
          border: 'none',
          color: 'primaryColor_hover',
          bg: 'none',
        }}
        {...props}
      />
    );
  }

  if (variant === 'summaryEmail') {
    return (
      <BaseButton
        ref={ref}
        bg="none"
        backgroundColor="#EDEDED"
        color="primaryColor"
        _hover={{
          color: 'white',
          backgroundColor: 'primaryColor',
        }}
        // _focus={{
        //   color: 'white',
        //   backgroundColor: 'primaryColor',
        // }}
        _active={{
          color: 'white',
          backgroundColor: 'primaryColor',
        }}
        {...props}
      />
    );
  }

  // NOTE: I don't have a better name
  if (variant === 'rdvBtn') {
    return (
      <BaseButton
        ref={ref}
        bg="none"
        color="primaryColor"
        _hover={{
          color: 'white',
          backgroundColor: 'primaryColor',
        }}
        // _focus={{
        //   color: 'white',
        //   backgroundColor: 'primaryColor',
        // }}
        _active={{
          color: 'white',
          backgroundColor: 'primaryColor',
        }}
        {...props}
      />
    );
  }

  if (variant === 'skip') {
    return (
      <BaseButton
        // mr="-10px"
        ref={ref}
        color="secondaryColor"
        rightIcon={
          <Box>
            <ImArrowRight2 />
          </Box>
        }
        bg="none"
        backgroundColor="none"
        padding="0px 20px !important"
        _hover={{
          color: 'primaryColor_hover',
          bg: 'none',
        }}
        _focus={{
          border: 'none',
        }}
        _active={{
          border: 'none',
          color: 'primaryColor_hover',
          bg: 'none',
        }}
        {...props}
      />
    );
  }

  return <BaseButton ref={ref} variant={variant || 'reno'} {...props} />;
});

export default Button;
